import React, { Component } from 'react'
import { Tooltip, Modal, Button, Input, Drawer, Rate, message, Popover } from 'antd';
import { withRouter } from 'react-router-dom'
import './index.css'
import customer from './img/customer.png'
import arrowRight from './img/arrow-right.png'
import arrowLeft from './img/arrow-left.png'
import { connect } from 'react-redux'
import { saveOnlineService } from 'src/store/actionCreators';
import icon_trans from './img/icon-trans.png'
import icon_arrow from './img/icon-arrow.png'
import Axios from 'axios';
import CustomModal from '../components/CustomModal/index';

const content = (
  <img src="images/tempImgs/底部说明/qrCode.png" className='qrCode'>
  </img>
);
const { TextArea } = Input;

class OnlineService extends React.Component {

  state = {
    visible: false,//控制在线客服窗口的显隐
    evaluateVisible: false,//控制客服评价窗口的显隐
    messageList: [{ flag: '1', info: '您好，请问有什么能为您服务？' }],//会话列表
    isUnfowld: true,//控制抽屉是否展开
    textareaValue: '',//textarea中的数据
    questionType: 0,
    servicerId: '',
    questionList: [],
    questionPage: [],
    score: 5
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.messageList.length !== this.props.messageList.length) {
      setTimeout(() => {
        // this.props.saveOnlineService([answer])
        this.scrollToBottom()
      }, 500)
      return true
    }
    return true
  }
  componentDidMount = () => {
    this.getQuestions(1)
  }
  //使滚动条至屏幕底部
  scrollToBottom = () => {
    console.log('滚动条至屏幕底部')
    var bar = document.getElementById('scrollView');
    if (!bar)
      return;
    bar.scrollIntoView({ behavior: 'smooth' })
  }
  getQuestions = (page) => {
    let _this = this
    Axios({
      url: global.url.im + '/smartreply/changeByPage',
      method: 'get',
      params: {
        limit: 5,
        page: page
      }
    }).then(res => {
      console.log('问题列表', res)
      if (res.data.payload.records) {
        _this.setState({
          questionList: res.data.payload.records,
          questionPage: [page, res.data.payload.pages]
        })
      }
    })
  }
  answerQ = (value) => {
    console.log(value)
    let question = {
      flag: "0",
      info: value.question
    }
    let answer = {
      flag: "1",
      info: value.answer
    }
    this.props.saveOnlineService([question, answer])
    setTimeout(() => {
      // this.props.saveOnlineService([answer])
      this.scrollToBottom()
    }, 500)
  }
  shiftQusetion = () => {
    let page = this.state.questionPage
    let curPage = page[0]
    let toatalPage = page[1]
    console.log(curPage, toatalPage)
    if (curPage === toatalPage) {
      this.getQuestions(1)
    } else {
      this.getQuestions(curPage + 1)
    }
  }
  submitInfo = () => {
    console.log("对话")
  }

  closeConmunication = () => {
    this.setState({
      visible: false,
    })
  }
  inConmunication = () => {
    this.setState({
      visible: true
    })
  }

  determine = () => {
    let _this = this;
    const linkTmp = document.createElement('a');
    linkTmp.href = 'ydspacebasedbee://';


    linkTmp.onclick = function (e) {
      _this.callapp_openClient({
        callbackTrue: function () {
          message.success("准备打开客户端");
        },
        callbackFlase: function () {
          message.info("检测到本机未安装客户端，请先安装客户端！");
          // window.open('https://caplos.aircas.ac.cn/oss/group1/M00/1C/B8/rBIACmWmOLKAGfkDJ3BTjSVQU8g290.exe',"_blank")
          const link = document.createElement('a');
          link.href = 'https://caplos.aircas.ac.cn/oss/group1/M00/1D/FE/rBIAB2bs0R2AVIbLFLridyNmEaw852.exe';
          link.download = '';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
    linkTmp.click();
  }

  callapp_openClient = ({ callbackTrue, callbackFlase }) => {
    var t = setTimeout(callbackFlase, 1000);
    var inp = document.createElement("input");
    inp.style.position = "absolute";
    inp.style.clip = "rect(0, 0, 0, 0)";
    // 出现下载框的时候往下跳的问题
    inp.style.top = '0'
    inp.style.left = '0'

    // inp.style.display="none";
    function blur() {
      window.clearTimeout(t);
      callbackTrue();
    }

    inp.addEventListener("blur", blur); // 监听blur事件
    document.body.appendChild(inp);
    inp.focus(); // 获取焦点
    setTimeout(function () { // 删除无用的标签
      inp.removeEventListener("blur", blur);
      document.body.removeChild(inp);
    }, 1000);
    //有客户端 如果有本地exe应用，就会弹框，input失去焦点，然后执行blur()事件 清空t定时器 - 删除无用的标签定时器
    //无客户端 不会弹框，input也不会失去焦点 触发t定时器- 执行callback - 删除无用的标签定时器
  }

  closeEvaluate = (e) => {
    let score = 0
    switch (this.state.score) {
      case 0:
        score = 0
        break;
      case 0.5:
        score = 1
        break;
      case 1:
        score = 2
        break;
      case 1.5:
        score = 3
        break;
      case 2:
        score = 4
        break;
      case 2.5:
        score = 5
        break;
      case 3:
        score = 6
        break;
      case 3.5:
        score = 7
        break;
      case 4:
        score = 8
        break;
      case 4.5:
        score = 9
        break;
      case 5:
        score = 10
        break;
      default:
        break;
    }
    console.log(e, score)

    Axios.get(`/gateway/api/instant-messaging/osevaluate/evaluate?score=${score}&userId=${this.state.servicerId}`).then(res => {
      message.success('评价成功')
    }).catch(err => {
      message.error('评价失败')
    }).finally(() => {
      this.setState({ evaluateVisible: false })
    })
  }

  selectImg = () => {
    console.log("选择图片")

  }

  selectFiles = () => {
    console.log("选择文件")
  }

  serachHistory = () => {
    console.log("调取聊天记录")
  }

  selectEmoji = () => {
    this.emoji.show()
  }

  jump = () => {
    var div = document.getElementById('orientate')
    div.scrollTop = div.scrollHeight
  }


  isDrawerUnfowld = () => {
    this.setState({
      isUnfowld: !this.state.isUnfowld
    }, () => {
      if (this.state.isUnfowld === false) {
        document.getElementById("Drawer").removeAttribute("hidden")
        document.getElementById("Drawer").classList.add("hidden")
      } else {
        document.getElementById("Drawer").removeAttribute("show")
        document.getElementById("Drawer").classList.add("show")
      }
    })
  }

  sendMessage = async (event) => {
    var div = document.getElementById('orientate')
    let question = {
      flag: "0",
      info: this.state.textareaValue
    }
    console.log("servicerId", this.state.servicerId, "textareaValue", this.state.textareaValue)
    if (this.state.servicerId && this.state.textareaValue) {
      console.log(this.state.servicerId)
      global.client.servicerSend(this.state.servicerId, this.state.textareaValue, 'text').then(res => {
        console.log(res)
        this.props.saveOnlineService(question)
        setTimeout(() => {
          // this.props.saveOnlineService([answer])
          this.scrollToBottom()
        }, 500)
        this.setState({ textareaValue: '' })
      })
    } else if (!this.state.servicerId) {
      let answer = {
        flag: "1",
        info: "为您转接人工客服，回答您的问题"
      }
      this.props.saveOnlineService([question, answer])
      setTimeout(() => {
        // this.props.saveOnlineService([answer])
        this.scrollToBottom()
      }, 500)
      Axios({
        method: 'GET',
        url: global.url.im + '/utils/getServicerId',
        params: { userId: this.props.user.userId }
      }).then(res => {
        let answer2
        switch (res.data.code) {
          case "100":
            break;
          case "200":
            answer2 = {
              flag: '1',
              info: '客服繁忙，您已进入排队序列'
            }
            break;
          case "300":
            answer2 = {
              flag: '1',
              info: res.data.payload + '号客服为您服务'
            }
            break;
          case "500":
            answer2 = {
              flag: '1',
              info: '目前没有客服在线'
            }
            break;
          default:
            break;
        }
        console.log(res)
        this.props.saveOnlineService(answer2)
        global.client.servicerSend(res.data.payload, this.state.textareaValue, 'text')
        this.setState({ servicerId: res.data.payload, textareaValue: '' })
      })
    }
  }

  closeMessage = () => {
    Axios({
      url: global.url.im + '/utils/serviceEnd',
      method: 'post',
      params: {
        servicerId: this.state.servicerId
      }
    }).then(res => {
      console.log(res)
    })
    if (!this.state.servicerId) {
      this.setState({
        visible: false,
      })
    } else {
      this.setState({
        visible: false,
        evaluateVisible: true,
      })
    }
  }

  updataValue = (event) => {
    this.setState({
      textareaValue: event.target.value
    })
    // this.setState({textareaValue:event.target.value})
  }

  jumpToOnlineHelp() {
    let type = this.state.questionType;
    // debugger
    switch (type) {
      case 1:
        // this.props.history.push('/onlineHelp')
        this.props.history.push({ pathname: `/onlineHelp` })
        break;
      case 2:
        this.props.history.push('/onlineHelp')
        // window.location.href="http://localhost:3001/#/onlineHelp:2"
        break;
      default:
        break;
    }
  }


  render() {
    const { messageList, isUnfowld, textareaValue, questionType } = this.state
    return (
      <>
        <div className='onlineservice-downLoad'>
          <div className='onlineservice-downLoadMain'>
            <Tooltip title="在线客服" placement='left'>
              <div className="onlineservice-popover">
                <img onClick={this.inConmunication} className="onlineservice-popover-img" src={require("./img/onlineService.png")} />
              </div>
            </Tooltip>
            <Tooltip title="pc端" placement='left'>
              <div className="onlineservice-popover">
                <img onClick={this.determine} className="onlineservice-popover-img" src={require("./img/desktop.png")} />
              </div>
            </Tooltip>
            {/*<Popover content={content} placement='left'>*/}
            {/*  <div className="onlineservice-popover">*/}
            {/*    <img className="onlineservice-popover-img" src={require("./img/phone.png")} />*/}
            {/*  </div>*/}
            {/*</Popover>*/}
            {/* <a style={{ marginBottom: '10px' }} className='Guide_BottomTitle_RightDesktop' target="_blank" href={'http://caplos.aircas.ac.cn/oss/group1/M00/1C/B8/rBIACmWmOLKAGfkDJ3BTjSVQU8g290.exe '}>
              <img className='Guide_BottomTitle_RightDesktop_Icon' src={require("./img/desktop.png")} />
            </a> */}
          </div>
        </div>

        <Modal
          className="onlineservice-modal"
          title="在线客服"
          visible={this.state.visible}
          onCancel={this.closeConmunication}
          maskClosable={false}
          footer={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {this.state.servicerId ? <Button className={'onlineservice-modal-button-active'} onClick={this.closeMessage}>结束会话</Button> : <div>{this.state.servicerId}</div>}
              <Button className={textareaValue === "" ? 'onlineservice-modal-button' : 'onlineservice-modal-button-active'} onClick={this.sendMessage}>发送</Button>
            </div>}
        >
          <div id={"orientate"} className="onlineservice-modal-info">
            <Question questionList={this.state.questionList} answerQ={(e) => { this.answerQ(e) }} shiftQusetion={this.shiftQusetion}></Question>
            {
              this.props.messageList.map((item, index) => {
                return (
                  item.flag === "1" ?
                    <>
                      <div key={index} className="onlineservice-service-info">
                        <div className="onlineservice-service-info-title">
                          <img src={customer} className="onlineservice-service-avatar"></img>
                          <div className="onlineservice-service-name">{index == 1 ? "智能客服" : this.props.onlineServiceId}</div>
                        </div>
                        <div className="onlineservice-service-content" onClick={() => this.jumpToOnlineHelp()} style={questionType != 0 ? { cursor: "pointer" } : null}
                          dangerouslySetInnerHTML={{
                            __html: item.info
                          }}
                        ></div>
                      </div>
                    </> : item.flag === "0" ?
                      <>
                        <div key={index} className="onlineservice-self-info">
                          <img src={customer} className="onlineservice-self-avatar"></img>
                          <div className="onlineservice-self-content">{item.info}</div>
                        </div>
                      </> : <Question questionList={this.state.questionList} answerQ={(e) => { this.answerQ(e) }} shiftQusetion={this.shiftQusetion}></Question>
                )
              })
            }
            <div id='scrollView' />
          </div>
          <div className="onlineservice-modal-tools">
            <div className="onlineservice-modal-emojiwrap">
              <img onClick={this.selectEmoji} className="onlineservice-modal-emoji" src={require('./img/icon-emoji.png')} />
            </div>
          </div>
          <TextArea
            className="onlineservice-modal-textarea"
            id='onlineservice-modal-textarea'
            onChange={this.updataValue}
            value={textareaValue}
          ></TextArea>
          <CustomModal className='chat-emoji-panel' backopcity={0.01} backclose ref={(ref) => { this.emoji = ref }}>
            <Emoji
              close={() => { this.emoji.close() }}
              setvalue={(str) => { this.setState({ textareaValue: str }) }}
            // value={this.state.textAreaValue}
            ></Emoji>
          </CustomModal>
        </Modal>

        <Modal
          className="onlineservice_evaluateModal"
          title="客服评价"
          visible={this.state.evaluateVisible}
          closable={false}
          maskClosable={false}
          footer={<Button type="primary" onClick={this.closeEvaluate}>评价</Button>}
        >
          <div className="onlineservice_evaluateModal_content">
            <div className="onlineservice_evaluateModal_contentTitle">请给本次客服服务评价！</div>
            <div className="onlineservice_evaluateModal_contentCenter">
              <img src={customer} className="onlineservice_evaluateModal_contentImg"></img>
              <div>客服{this.state.servicerId}号</div>
            </div>
            <Rate allowHalf
              className="onlineservice_evaluateModal_contentEvaluate"
              onChange={e => this.setState({ score: e })}
              value={this.state.score}
            />
          </div>
        </Modal>
      </>
    )
  }
}
const mapDispatch = dispatch => ({
  saveOnlineService(param) {
    dispatch(saveOnlineService(param))
  }
})
const mapState = (state) => ({
  user: state.userReducer.get('user').toJS(),
  messageList: state.messageReducer.get('onlineServiceList').toJS(),
  onlineServiceId: state.messageReducer.get('onlineServiceId')
})
export default connect(mapState, mapDispatch)(withRouter(OnlineService));


class Question extends Component {
  render() {
    return (
      <div className="onlineservice-service-info">
        <div className="onlineservice-service-info-title">
          <img src={customer} className="onlineservice-service-avatar"></img>
          <div className="onlineservice-service-name">智能客服</div>
        </div>
        <div className="onlineservice-service-question">
          <div className='onlineservice-questionTop'>
            <div className='onlineservice-questionTop-text'>猜你想问</div>
            <img className='onlineservice-questionTop-trans' src={icon_trans} style={{ height: '20px', cursor: 'pointer' }} onClick={this.props.shiftQusetion} />
          </div>
          {
            this.props.questionList.map((value, index) => {
              return (
                <div className='onlineservice-questionCell' onClick={() => { this.props.answerQ(value) }}>
                  <div className="onlineservice-questionList">{value.question}</div>
                  <img src={icon_arrow} style={{ height: '20px' }}></img>
                </div>
              )

            })
          }
        </div>
      </div>
    )
  }
}


const Emoji = (props) => {
  // state = {
  //     emojiValue : ""
  // }
  const emoji = [{
    groupname: '',
    group: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😇', '😉', '😊',
      '🙂', '🙃', '☺', '😋', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '🤪', '😜',
      '😝', '😛', '🤑', '😎', '🤓', '🧐', '🤠', '🥳', '🤗', '🤡', '😏', '😶', '😐',
      '😑', '😒', '🙄', '🤨', '🤔', '🤫', '🤭', '🤥', '😳', '😞', '😟', '😠', '😡',
      '🤬', '😔', '😕', '🙁', '☹', '😬', '🥺', '😣', '😖', '😫', '😩', '🥱', '😤',
      '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '🤤', '😓', '😭',
      '🤩', '😵', '🥴', '😲', '🤯', '🤐', '😷', '🤕', '🤒', '🤮', '🤢', '🤧', '🥵',
      '🥶', '😴', '💤', '😈', '👿', '👹', '👺']
  }]


  // console.log('😡😡😡😡😡😂😡😡😡😂'.split(''));
  function insertemoji(char) {
    var textarea = document.getElementById('onlineservice-modal-textarea')
    var textareaStr = textarea.value;
    var start = textarea.selectionStart
    var end = textarea.selectionEnd
    console.log('ceshi', char)
    if (!textareaStr) textareaStr = ''
    let str = textareaStr.substring(0, start) + char + textareaStr.substring(end)
    props.setvalue(str)

    // props.close()
    textarea.focus()
    // textarea.selectionStart=start
  }
  return (<div className='chat-emoji-back'>
    {
      emoji[0].group.map((char, index) => {
        return (<div className='emoji' key={index} style={{ float: 'left', cursor: 'pointer' }} onClick={insertemoji.bind(this, char)}>{char}</div>)
      })
    }
  </div>)
}

